import { merge } from '../../helper';

import hasClass from '../../general/class/hasClass';

import * as exAlert from '../../components/alert';
import * as exTab from '../../components/tab';

import * as exInput from '../input';
import * as exSelect from '../select';

// ----------------------------------------------------------------------------

export type TypeElements = any;

export type TypeGeneralConfig = {
    alert?: Record<string, any>;
    input?: Record<string, any>;
    select?: Record<string, any>;
    tab?: Record<string, any>;
};

// ----------------------------------------------------------------------------

function general(elements: TypeElements, config?: TypeGeneralConfig): void {
    alert(elements, config?.alert);
    input(elements, config?.input);
    select(elements, config?.select);
    tab(elements, config?.tab);
}

// ----------------------------------------------------------------------------

function alert(elements: TypeElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        className: 'alert',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        if (hasClass(element, defConfig.className)) {
            exAlert.close(element);
        }
    }
}

function input(elements: TypeElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        tagName: ['input', 'textarea'],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        const tagName = element.tagName.toLowerCase();

        if (defConfig.tagName.includes(tagName)) {
            exInput.reset.validation(element, config);
        }
    }
}

function select(elements: TypeElements, config?: Record<string, any>): void {
    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        if (element instanceof HTMLSelectElement) {
            exSelect.reset.validation(element, config);
        }
    }
}

function tab(elements: TypeElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        className: 'nav nav-tabs',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        if (hasClass(element, defConfig.className)) {
            exTab.reset.validation(element, config);
        }
    }
}

// ----------------------------------------------------------------------------

export { general, alert, input, select, tab };
